import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../hooks/useUser";
import { ProFormTabs } from "../../pages/pro/createEditProfile/tabs";
import { ReactComponent as AlertTriangleIcon } from "../../assets/svg/alert-triangle.svg";

const ContactReminderBanner = ({ sx }: { sx?: object }) => {
  const navigate = useNavigate();
  const { user } = useUser();
  const u = user as any;

  const missing = [
    !u?.phoneNumber?.trim?.() && "phone number",
    !(u?.address1?.trim?.() && u?.city?.trim?.()) && "mailing address"
  ].filter(Boolean) as string[];

  if (!missing.length) return null;

  const goToProfileContact = () =>
    navigate(`/profile?tab=${encodeURIComponent(ProFormTabs.ContactInfo)}`);

  const message = `Fulfillment uses this to reach you after selection. Your profile is missing your ${missing.join(
    " and "
  )}.`;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        p: 2,
        borderRadius: "12px",
        backgroundColor: "var(--tint)",
        // gold hairline kept literal — no token matches it and --border washes
        // out against --tint in light mode
        border: "1px solid #F0E0BE",
        ...sx
      }}
    >
      <Box sx={{ color: "var(--accent-text)", flexShrink: 0, mt: "1px", lineHeight: 0 }}>
        <AlertTriangleIcon width={18} height={18} />
      </Box>
      <Box>
        <Typography
          sx={{
            fontFamily: "CircularStd",
            fontWeight: 700,
            fontSize: "13px",
            color: "var(--text)"
          }}
        >
          Make sure your contact info is up to date
        </Typography>
        <Typography
          sx={{
            fontFamily: "CircularStd",
            fontSize: "12px",
            color: "var(--text-2)",
            mt: 0.25
          }}
        >
          {message}{" "}
          <Box
            component="span"
            onClick={goToProfileContact}
            sx={{
              color: "var(--accent-text)",
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline"
            }}
          >
            Update profile
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactReminderBanner;
